import ManualBill from '../../../bills/components/create/ManualBill';
import { BillContext } from '../../../bills/types/Bill';

export default function ManualReviewBillScreen() {
    return <ManualBill context={BillContext.REVIEW} />;
}
